import { AnimatePresence } from "framer-motion"
import { Link } from "gatsby"
import React, { useState } from "react"
import styled from "styled-components"
import { _sluggedName } from "../../../utils/utils"
import { Flex } from "../../layout/reusables"
import { colors } from "../../styles/colors"
import { Heading } from "../../styles/typography"
import ArticlePreviewItem from "./article-preview-item"
import AudioPreviewItem from "./audio-preview-item"
import {
    ARTICLE_TYPE,
    PHOTO_TYPE,
    VIDEO_TYPE,
    AUDIO_TYPE,
} from "./content-types"
import PhotoPreviewItem from "./photo-preview.item"
import PhotoViewerModal from "./photo-viewer-modal"
import VideoPlayerModal from "./video-player-modal"
import VideoPreviewItem from "./video-preview.item"
// import { useQueryParam, NumberParam, StringParam } from "use-query-params";

export default function OriginalContentGroup({ originalContentData, name, logo }) {

    const [videoModalOpen, setVideoModalOpen] = useState(false)
    const [photoModalOpen, setPhotoModalOpen] = useState(false)
    const [selectedVideo, setSelectedVideo] = useState(null)
    const [selectedPhoto, setSelectedPhoto] = useState(null)

    const articles = originalContentData.filter(el => el.type === ARTICLE_TYPE)
    const photos = originalContentData.filter(el => el.type === PHOTO_TYPE)
    const videos = originalContentData.filter(el => el.type === VIDEO_TYPE)
    const audios = originalContentData.filter(el => el.type === AUDIO_TYPE)
    const sluggedName = _sluggedName(name)

    const handleSelectVideo = (videoItem) => {
        setSelectedVideo(videoItem)
        setVideoModalOpen(true)
    }
    const handleSelectPhoto = (photoItem) => {
        setSelectedPhoto(photoItem)
        setPhotoModalOpen(true)
    }

    return (
        <>
            {articles.length > 0 && (
                <AnimatePresence>
                    <div key="articles-content">
                        <Header id="article-group">
                            <Heading>Articles</Heading>
                            {/* {articles.length > 3 && (
                                <ViewMore to="/original-content/all?type=Article">
                                    View all articles
                                </ViewMore>
                            )} */}
                        </Header>
                        <ArticlesGrid>
                            {articles &&
                                articles
                                    .slice(0, 6)
                                    .map((item, index) => (
                                        <ArticlePreviewItem
                                            key={index}
                                            item={item}
                                            index={index}
                                            viewing
                                            name={sluggedName}
                                        />
                                    ))}
                        </ArticlesGrid>
                    </div>
                </AnimatePresence>
            )}
            {videos.length > 0 && (
                <AnimatePresence>
                    <div key="videos-content">
                        <Header id="video-group">
                            <Heading>Videos</Heading>
                            {/* {videos.length > 3 && (
                                <ViewMore to="/original-content/all?type=Video">
                                    View all videos
                                </ViewMore>
                            )} */}
                        </Header>
                        <Grid>
                            {videos &&
                                videos
                                    .slice(0, 3)
                                    .map((item, index) => (
                                        <VideoPreviewItem
                                            key={index}
                                            item={item}
                                            index={index}
                                            viewing
                                            name={sluggedName}
                                            selectVideo={handleSelectVideo}
                                        />
                                    ))}
                        </Grid>
                    </div>
                </AnimatePresence>
            )}
            
            {photos.length > 0 && (
                <AnimatePresence>
                    <div key="photos-content">
                        <Header id="photo-group">
                            <Heading>Photos</Heading>
                            {/* {photos.length > 3 && (
                                <ViewMore to="/original-content/all?type=Photo">
                                    View all photos
                                </ViewMore>
                            )} */}
                        </Header>
                        <Grid>
                            {photos &&
                                photos
                                    .slice(0, 3)
                                    .map((item, index) => (
                                        <PhotoPreviewItem
                                            key={index}
                                            item={item}
                                            index={index}
                                            viewing
                                            name={sluggedName}
                                            selectPhoto={handleSelectPhoto}
                                        />
                                    ))}
                        </Grid>
                    </div>
                </AnimatePresence>
            )}

            {audios.length > 0 && (
                <AnimatePresence>
                    <div key="audios-content">
                        <Header id="audio-group">
                            <Heading>Audio</Heading>
                            {/* {audios.slice(0, 3).length > 3 && (
                                <ViewMore to="/original-content/all?type=Audio">
                                    View all audio
                                </ViewMore>
                            )} */}
                        </Header>
                        <Grid>
                            {audios &&
                                audios.map((item, index) => (
                                    <AudioPreviewItem
                                        key={index}
                                        item={item}
                                        index={index}
                                        viewing
                                        name={sluggedName}
                                    />
                                ))}
                        </Grid>
                    </div>
                </AnimatePresence>
            )}
            {selectedVideo &&
                <VideoPlayerModal
                    name={name}
                    logo={logo}
                    open={videoModalOpen}
                    setOpen={setVideoModalOpen}
                    video={selectedVideo}
                    />
                }
            {selectedPhoto &&
                <PhotoViewerModal
                    open={photoModalOpen}
                    setOpen={setPhotoModalOpen}
                    photo={selectedPhoto}
                    name={name}
                    logo={logo}
                />
            }
        </>
    )
}

const Header = styled(Flex)`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
`
const ViewMore = styled(Link)`
    color: ${colors.blue};
    text-decoration: none;
    font-weight: 500;
`
const Grid = styled.div`
    display: grid;
    margin-bottom: 80px;
    grid-gap: 20px;
    /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
    grid-template-columns: repeat(3, 1fr);
    width: 100%;

    @media (max-width: 550px) {
        grid-gap: 10px;
        grid-template-columns: repeat(1, 1fr);
    }
`
const ArticlesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px 20px;
    margin-bottom: 80px;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 550px) {
        grid-template-columns: repeat(1, 1fr);
        gap: 40px 15px;
    }
`;
